import ErrorFallback from "./ErrorFallback";

function PageErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <ErrorFallback
      error={error}
      resetErrorBoundary={resetErrorBoundary}
      variant="page"
    />
  );
}

export default PageErrorFallback;
